import {Pipe, PipeTransform} from "@angular/core";
import moment from "moment";

@Pipe({name: 'momentJs'})
export class MomentjsPipe implements PipeTransform {
  transform(value: Date, format?: string): string {
    if (!format || format == 'relative')
      return moment(value).locale('nl').fromNow().toString();
    return moment(value).locale('nl').format(format);
  }
}
